import Request from '../utilis/request';
import {createElement} from "../utilis/helper";
import config from "../config";
export function upload(files, path) {
    return Request({
        url: config.config.base_url+'/api/upload/'+path,
        method: 'post',
        data: files
    })
}
export function uploadAndChangeDPI(files, path, width = null, height = null) {
    return Request({
        url: config.config.base_url+'/api/upload/dpi/'+path+'/'+width+'/'+height,
        method: 'post',
        data: files
    })
}
export function uploadSmake(files) {
    return Request({
        url: config.config.base_url+'/api/upload/smake',
        method: 'post',
        data: files
    })
}
export function uploadSize(files) {
    return Request({
        url: config.config.base_url+'/api/upload/size',
        method: 'post',
        data: files
    })
}
export function uploadPreviewPhotos(files){
    return Request({
        url: config.config.base_url+'/api/upload/preview/photos',
        method: 'post',
        data: files
    })
}
export function copy(file, path) {
    return Request({
        url: config.config.base_url+'/api/copy/photo/'+path,
        method: 'post',
        data: file
    })
}
export function updateFile(data) {
    return Request({
        url: config.config.base_url+'/api/upload/update',
        method: 'post',
        data: data
    })
}
export function removeFile(data) {
    return Request({
        url: config.config.base_url+'/api/upload/remove',
        method: 'post',
        data: data
    })
}
export function getUserUploads(params){
    return Request({
        url: config.config.base_url+'/api/upload/getuploads',
        method: 'get',
        params: params
    })
}

export function getUserTaxPdf(params) {
    return Request({
        url: config.config.base_url+'/api/upload/gettaxpdf',
        method:'get',
        params: params
    })
}

export function deleteUserTaxPdf(filename) {
    return Request({
        url: config.config.base_url+'/api/upload/deletetaxpdf',
        method:'POST',
        data: filename
    })
}

export function uploadUserTaxPdf(data) {
    return Request({
        url: config.config.base_url+'/api/upload/uploadtaxpdf',
        method:'POST',
        data: data
    })
}

export function uploadEmbroideryFile(data){
    return Request({
        url: config.config.base_url+'/api/upload/embroidery',
        method:'POST',
        data: data
    })
}

export function uploadDiscountCsv(data) {
    return Request({
        url: config.config.base_url+'/api/upload/discountcsv',
        method:'POST',
        data: data
    })
}

export function download(paths) {
    var values = paths;
    const form = document.createElement('form');
    form.method = 'GET';
    form.action = config.config.base_url+'/download';

    for (var property in values) {
        if (values.hasOwnProperty(property)) {
            var value = values[property];
            if (value instanceof Array) {
                for (var i = 0, l = value.length; i < l; i++) {
                    form.appendChild(createElement("input", {type: "hidden",
                        name: property+'[]',
                        value: value[i]}));
                }
            }
            else {
                form.appendChild(createElement("input", {type: "hidden",
                    name: property,
                    value: value}));
            }
        }
    }
    document.body.appendChild(form);
    form.submit();
}

export function createCat(data) {
    return Request({
        url: config.config.base_url+'/api/upload/createDir',
        method: 'post',
        data: data
    })
}

export function getMedia(){
    return Request({
        url: config.config.base_url+'/api/upload/get/media',
        method:'get'
    })
}

export function getImages(params){
    return Request({
        url: config.config.base_url+'/api/upload/get/images',
        method:'get',
        params: params
    })
}
export function downloadImage(params){
    return Request({
        url: config.config.base_url+'/api/upload/download/image',
        method:'get',
        params: params
    })
}

